export function filterRoutes(routes, accessData) {
  // Extract allowed names from accessData
  const allowedNames = new Set(accessData?.map((item) => item.name));

  // Recursive function to filter routes
  const filterRecursive = (routes) => {
    return routes
      .filter((route) => {
        const hasValidCollapse =
          route.collapse && filterRecursive(route.collapse).length > 0;
        return allowedNames.has(route.name) || hasValidCollapse;
      })
      .map((route) => ({
        ...route,
        collapse: route.collapse ? filterRecursive(route.collapse) : undefined,
      }));
  };

  // Filter the top-level routes
  return filterRecursive(routes);
}
